export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_211143.c901aac1.jpg";